<template>
  <div class="dataMonitor" ref="dataMonitor" @mouseenter="enter()" @mouseleave="leave()">
    <div class="bg_box"></div>
    <div class="tab">
      <el-select v-model="optionIndex" filterable placeholder="请选择" @change="change()">
        <el-option v-for="(item, i) in options" :key="i" :label="item.name" :value="item.num">
        </el-option>
      </el-select>
    </div>
    <div class="contain_box" @click="clickFuc">
      <div class="left_part">
        <div class="charts">
          <div class="chart2">
            <div class="chart_column" ref="chart2"></div>
          </div>
        </div>
      </div>
      <div class="right_part">
        <div class="title_line">
          <div class="button_box">
            <a class="home_tab_button" v-for="(item, i) in selectArr" :key="i" :class="{ home_tab_actived: selectIndex == i + 1 }" @click.stop="handleItem(i + 1)">{{ item.name }}</a>
          </div>
          <div class="total_hours">
            {{selectArr[selectIndex-1]&&selectArr[selectIndex-1].name}}累:<span class="number">{{allHour}}</span>小时
          </div>
        </div>
        <div class="line2">
          <div class="line2_left">
            类型
          </div>
          <div class="line2_right">
            运行/总数（台）
          </div>
        </div>
        <div class="mointor_box">
          <div class="line line_1">
            <div class="line_l">
              生产设备监控
            </div>
            <div class="line_r">
              <div class="r_l number">{{dataList.production.onlinrCount}}</div>
              <div class="r_r number">{{dataList.production.allCount}}</div>
            </div>
          </div>
          <div class="line line_2">
            <div class="line_l">
              治理设备监控
            </div>
            <div class="line_r">
              <div class="r_l number">{{dataList.government.onlinrCount}}</div>
              <div class="r_r number">{{dataList.government.allCount}}</div>
            </div>
          </div>
          <div class="line line_3">
            <div class="line_l">
              监测设备监控
            </div>
            <div class="line_r">
              <div class="r_l number">{{dataList.monitor.onlinrCount}}</div>
              <div class="r_r number">{{dataList.monitor.allCount}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getOptBar from "./chartBar.js";
import { unwarp } from "@/utils/tools.js";
import { mapState, mapGetters } from "vuex";
import deviceManageDialog from "./../deviceManage/components/deviceManageDialog";
import { setPageActive } from '@/utils/platformmonitor.js'
export default {
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: 'dataMonitor.vue',
      computedName: '全厂数据监控系统组件',
      customerId: this.$store.state.customerId,
      chart2: null,
      allCount: 9,
      allCountArr: [],
      unit: 2,
      selectIndex: 0,
      selectArr: [
        { name: "日" },
        { name: "周" },
        { name: "月" },
        { name: "年" },
      ],
      optionIndex: 1,
      options: [
        { name: "生产设备", num: 1 },
        { name: "治理设备", num: 2 },
      ],
      dataList: {
        production: {
          allCount: 0,
          onlinrCount: 0,
        },
        government: {
          allCount: 0,
          onlinrCount: 0,
        },
        monitor: {
          allCount: 0,
          onlinrCount: 0,
        },
      },
      setTimeAutoMove: null,
      dataBox: [],
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    allHour() {
      return this.allCountArr[this.selectIndex - 1];
    },
  },
  unmounted() {
    if (this.chart2) {
      this.chart2.dispose();
      this.chart2 = null;
    }
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
    if (this.setTimeAutoMove) {
      clearTimeout(this.setTimeAutoMove);
    }
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.dataMonitor).outerWidth();
    let h = $(that.$refs.dataMonitor).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.handleItem(1);
  },
  methods: {
    autoChange() {
      // return //先注释，后期上线解除

      if (this.selectIndex > 4) {
        this.selectIndex = 1;
      }
      if (
        this.dataBox[this.selectIndex - 1] &&
        this.dataBox[this.selectIndex - 1]["time"] &&
        this.dataBox[this.selectIndex - 1]["time"].length
      ) {
        if (!this.chart2) {
          this.chart2 = echarts.init(this.$refs.chart2);
        }
        unwarp(this.chart2).setOption(
          getOptBar(this.dataBox[this.selectIndex - 1])
        );
      } else {
        this.getAllData();
      }
      if (this.setTimeAutoMove) {
        clearTimeout(this.setTimeAutoMove);
      }
      this.setTimeAutoMove = setTimeout(() => {
        this.selectIndex += 1;
        this.autoChange();
      }, 8000);
    },
    enter() {
      if (this.setTimeAutoMove) {
        clearTimeout(this.setTimeAutoMove);
      }
    },
    leave() {
      if (this.setTimeAutoMove) {
        clearTimeout(this.setTimeAutoMove);
      }
      this.setTimeAutoMove = setTimeout(() => {
        this.autoChange();
      }, 30000);
    },
    async handleItem(index) {
      this.selectIndex = index;
      await this.getAllData();
      this.autoChange();
    },
    async getAllData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      await this.getData1();
      await this.getData2();
      this.setTime1 = setTimeout(() => {
        this.getAllData();
      }, 1000 * 60);
    },
    async getData1() {
      let that = this;
      let deviceRunTimeUrl = CONFIG.requestName + this.$apiOpt.deviceRunTime;
      let data = await that.$apiUtils.get(deviceRunTimeUrl, {
        customerId: that.customerId,
        type: that.optionIndex,
        timeType: that.selectIndex,
      });
      let sumTime = data?.sumTime;
      let count = parseInt(sumTime);
      this.allCountArr[that.selectIndex - 1] = count;
      let runTimeList = data.list;
      if (!that.chart2) {
        that.chart2 = echarts.init(that.$refs.chart2);
      }
      let result;
      if (that.selectIndex === 1) {
        result = that.convertListByHour2(runTimeList);
      } else if (that.selectIndex === 2) {
        result = that.convertListByWeek(runTimeList);
      } else if (that.selectIndex === 3) {
        result = that.convertListByMonth(runTimeList);
      } else if (that.selectIndex === 4) {
        result = that.convertListByYear(runTimeList);
      }
      this.dataBox[that.selectIndex - 1] = result;
      unwarp(that.chart2).setOption(getOptBar(result));
    },
    async getData2() {
      let _this = this;
      let findDeviceAdministration =
        CONFIG.requestName + this.$apiOpt.findDeviceAdministration;
      let data = await _this.$apiUtils.get(findDeviceAdministration, {
        customerId: _this.customerId,
      });
      data &&
        data.forEach((v) => {
          if (v.primary_type_name == "生产设备") {
            this.dataList.production.allCount = v.count;
            this.dataList.production.onlinrCount = v.onLine;
          } else if (v.primary_type_name == "治理设备") {
            this.dataList.government.allCount = v.count;
            this.dataList.government.onlinrCount = v.onLine;
          } else if (v.primary_type_name == "监测设备") {
            this.dataList.monitor.allCount = v.count;
            this.dataList.monitor.onlinrCount = v.onLine;
          }
        });
    },
    convertListByHour2(data) {
      if (!data.length) return { time: [], value: [] };
      let arr = data.slice(-9);
      let returnData = { time: [], value: [] };
      arr.forEach((item) => {
        item.time = item.time.split(" ")[1];
        returnData.time.push(item.time);
        returnData.value.push(item.value);
      });
      return returnData;
    },
    convertListByWeek(list) {
      let resultObj = {};
      resultObj.time = [];
      resultObj.value = [];
      let obj = {}
      list.forEach(item => {
        let key = new Date(item.time.replace(/-0/g, '/').replace(/-/g, '/'))
        let time = key.getMonth() + 1 + '-' + key.getDate()
        let value = item.value && item.value.toFixed ? item.value.toFixed(2) : item.value
        if (obj[time]) {
          obj[time] += Number(value)
        } else {
          obj[time] = Number(value)
        }
        // resultObj.time.push(key.getMonth() + 1 + '-' + key.getDate())
        // obj[key.getMonth() + 1 + '-' + key.getDate()] =
        // resultObj.value.push(item.value && item.value.toFixed ? item.value.toFixed(2) : item.value)
      })

      for (let key in obj) {
        resultObj.time.push(key)
        resultObj.value.push(obj[key])
      }
      return resultObj
    },
    convertListByMonth(list) {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let week1 = month + "-1";
      let week2 = month + "-8";
      let week3 = month + "-15";
      let week4 = month + "-22";
      let result = {};
      result[week1] = 0;
      result[week2] = 0;
      result[week3] = 0;
      result[week4] = 0;
      let resultObj = {};
      list.forEach((element) => {
        let tmpTime = element.time;
        if (tmpTime) {
          let tempTs = new Date(
            tmpTime.replace(/-0/g, "/").replace(/-/g, "/")
          ).getTime();
          if (
            tempTs < new Date((year + "-" + week2).replace(/-/g, "/")).getTime()
          ) {
            result[week1] += parseFloat(element.value);
          } else if (
            tempTs < new Date((year + "-" + week3).replace(/-/g, "/")).getTime()
          ) {
            result[week2] += parseFloat(element.value);
          } else if (
            tempTs < new Date((year + "-" + week4).replace(/-/g, "/")).getTime()
          ) {
            result[week3] += parseFloat(element.value);
          } else {
            result[week4] += parseFloat(element.value);
          }
        }
      });
      resultObj.time = [];
      resultObj.value = [];
      for (let i in result) {
        resultObj.time.push(i);
        resultObj.value.push(
          result[i] && result[i].toFixed ? result[i].toFixed(2) : result[i]
        );
      }
      return resultObj;
    },
    convertListByYear(list) {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let week1 = "一季度";
      let week2 = "二季度";
      let week3 = "三季度";
      let week4 = "四季度";
      let week1_ = "4-1";
      let week2_ = "7-1";
      let week3_ = "10-1";
      let result = {};
      result[week1] = 0;
      result[week2] = 0;
      result[week3] = 0;
      result[week4] = 0;
      let resultObj = {};
      list.forEach((element) => {
        let tmpTime = element.time;
        if (tmpTime) {
          let tempTs = new Date(
            tmpTime.replace(/-0/g, "/").replace(/-/g, "/")
          ).getTime();
          if (
            tempTs <
            new Date((year + "-" + week1_).replace(/-/g, "/")).getTime()
          ) {
            result[week1] += parseFloat(element.value);
          } else if (
            tempTs <
            new Date((year + "-" + week2_).replace(/-/g, "/")).getTime()
          ) {
            result[week2] += parseFloat(element.value);
          } else if (
            tempTs <
            new Date((year + "-" + week3_).replace(/-/g, "/")).getTime()
          ) {
            result[week3] += parseFloat(element.value);
          } else {
            result[week4] += parseFloat(element.value);
          }
        }
      });
      resultObj.time = [];
      resultObj.value = [];
      for (let i in result) {
        resultObj.time.push(i);
        resultObj.value.push(
          result[i] && result[i].toFixed ? result[i].toFixed(2) : result[i]
        );
      }
      return resultObj;
    },
    change() {
      this.getAllData();
    },
    clickFuc() {
      this.pageTitleName= "全厂数据监控系统"
      this.$store.commit("dialogStatus", true);
      this.$popup.open(deviceManageDialog, this.dialogCompontent, this, {
        production: this.dataList.production.allCount,
        government: this.dataList.government.allCount,
        monitor: this.dataList.monitor.allCount,
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.dataMonitor {
  height: 250px;
  width: 600px;
  cursor: pointer;
  .bg_box {
    position: absolute;
    @include bg-box(564px, 211px, "bg.png");
    bottom: 5px;
    z-index: -1;
  }
  .tab {
    float: right;
    .el-select {
      width: 125px;
      height: 26px;
    }
  }
  .contain_box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: calc(100% - 20px);
    margin-top: 5px;
    .left_part {
      width: 250px;
      .charts {
        width: 100%;
        height: 100%;
        margin-right: 10px;
        .chart2 {
          width: 100%;
          height: 100%;
          .chart_column {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .right_part {
      width: 310px;
      padding-top: 5px;
      .title_line {
        display: flex;
        justify-content: space-between;
        padding-right: 10px;
        .button_box {
          z-index: 1;
          display: flex;
          padding-left: 16px;
          .home_tab_button {
            margin-right: 6px;
            @include bg-box(28px, 28px, "button.png");
            line-height: 28px;
            text-align: center;
          }
          .home_tab_actived {
            @include bg-box(28px, 28px, "button_selected.png");
          }
        }
        .total_hours {
          font-size: 16px;
          color: #ffffff;
          line-height: 28px;
          white-space: nowrap;
          span {
            font-size: 22px;
            color: #b6ffc6;
            line-height: 28px;
          }
        }
      }
      .line2 {
        display: flex;
        justify-content: space-between;
        margin: 5px 17px 0px 20px;
        .line2_left {
          width: 50%;
          font-size: 16px;
          color: #c8d8ff;
          line-height: 30px;
          padding-left: 9px;
        }
        .line2_right {
          @extend .line2_left;
          text-align: center;
        }
      }
      .mointor_box {
        height: 101px;
        margin: 7px 17px 0px 20px;
        .line {
          height: 30px;
          margin-bottom: 5px;
          display: flex;
          justify-content: space-between;
          .line_l {
            width: 50%;
            font-size: 16px;
            color: #c8d8ff;
            line-height: 30px;
            padding-left: 9px;
          }
          .line_r {
            width: 50%;
            display: flex;
            justify-content: space-between;
            .r_l,
            .r_r {
              width: 50%;
              text-align: center;
              font-size: 22px;
              color: #47ffdd;
              line-height: 30px;
            }
            .r_r {
              color: #f4c48f;
            }
          }
        }
      }
    }
  }
}
</style>

<style scoped>
.dataMonitor /deep/ .el-select .select-trigger .el-input .el-input__suffix-inner {
  display: flex;
}
.dataMonitor /deep/ .el-select .select-trigger .el-input .el-input__suffix-inner .el-icon-arrow-up {
  line-height: 26px;
}
</style>
